import { render } from "./FreightAnalysisPage.vue?vue&type=template&id=583ad268&scoped=true"
import script from "./FreightAnalysisPage.vue?vue&type=script&lang=js"
export * from "./FreightAnalysisPage.vue?vue&type=script&lang=js"

import "./FreightAnalysisPage.vue?vue&type=style&index=0&id=583ad268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583ad268"]])

export default __exports__